module.exports = __webpack_public_path__ + "static/media/LELE10.40547547.jpg";